import React, { useState } from 'react';
import { BlockWrapper, defineBlock, smartProps, useChildrenBlocks, useEditor } from '@smartfire/glue-ui/block';
import { EditableText } from '@smartfire/components';
import { InnerBlocks } from '@wordpress/block-editor';
import { TemplateArray } from '@wordpress/blocks';
import style from './style.module.scss';

const EngagementsBlock = () => {
    const { isEditing } = useEditor();
    const { children, Child } = useChildrenBlocks();
    const [currentSlide, setCurrentSlide] = useState(0);

    const TEMPLATE_BLOCKS: TemplateArray = [['smartfire/engagements-tab']];
    const ALLOWED_BLOCKS: string[] = ['smartfire/engagements-tab'];

    return (
        <BlockWrapper.Section className={style.engagements}>
            <EditableText smartProp="title" placeholder="Titre" className={style.title} tagName="h2" />

            <div className={style.list}>
                {isEditing ? (
                    <InnerBlocks template={TEMPLATE_BLOCKS} allowedBlocks={ALLOWED_BLOCKS} />
                ) : (
                    children?.map((child, index) => (
                        <Child
                            key={index}
                            index={index}
                            isCurrent={index === currentSlide}
                            defineAsCurrent={() => setCurrentSlide(index)}
                        />
                    ))
                )}
            </div>
        </BlockWrapper.Section>
    );
};

export default defineBlock({
    Block: EngagementsBlock,
    smartProps: {
        title: smartProps.string.withDefault('Nos engagements'),
    },
    setup: {
        title: 'Nos Engagements',
    },
});
